const calcPriceMargin = (margin, cost) => {
  return parseFloat(cost) / (1 - parseFloat(margin) / 100);
};

module.exports.calcPriceMargin = calcPriceMargin;
